/**
 * Reservation checkout mode enum.
 */
export enum ReservationCheckoutModeEnum {
	/**
	 * Expects payment to be made before reservation is created.
	 */
	WITH_PAYMENT = 'with_payment',

	/**
	 * Creates reservation without payment.
	 */
	WITHOUT_PAYMENT = 'without_payment',
}
